module.exports = __webpack_public_path__ + "static/media/ser_ser_sup.1e9842dc.png";